import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TRANSLATION_SCOPE } from '@modules/instructor/i18n/scope';

@Component({
  selector: 'app-instructor-request-complete',
  templateUrl: './instructor-request-complete.component.html',
  styleUrls: ['./instructor-request-complete.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InstructorRequestCompleteComponent implements OnInit {

  translationScope = TRANSLATION_SCOPE;
  
  constructor(private router: Router) {}

  ngOnInit() {}

  gotoHome(): void {
    this.router.navigateByUrl('/');
  }
}
